import React from "react"
import PropTypes from "prop-types"
import ClientPeriodConsumptionSummary from "./ClientPeriodConsumptionSummary.controller"
import ClientPeriodAverageConsumption from "./ClientPeriodAverageConsumption.controller"
import { CLIENT_SPRINT_STATES } from "../../../../consts/modules/clientReport.consts"
import ClientPeriodConsumptionDistribution from "./ClientPeriodConsumptionDistribution.controller"
import ClientPeriodBudgetState from "./ClientPeriodBudgetState.controller"
import { DateTime } from "luxon"

const ClientConsumption = ({
  refresh,
  triggerRefresh,
  dateRange,
  period,
  selectedPeriod,
}) => {
  return (
    <div className="flex flex-column gap-3">
      <ClientPeriodConsumptionSummary
        selectedPeriod={selectedPeriod}
        refresh={refresh}
        triggerRefresh={triggerRefresh}
      />
      <ClientPeriodAverageConsumption
        selectedPeriod={selectedPeriod}
        refresh={refresh}
        triggerRefresh={triggerRefresh}
      />
      <div className="flex gap-3 flex-wrap">
        <ClientPeriodConsumptionDistribution
          selectedPeriod={selectedPeriod}
          refresh={refresh}
          triggerRefresh={triggerRefresh}
        />
        <ClientPeriodBudgetState
          selectedPeriod={selectedPeriod}
          refresh={refresh}
          triggerRefresh={triggerRefresh}
        />
      </div>
    </div>
  )
}

export default ClientConsumption

ClientConsumption.propTypes = {
  refresh: PropTypes.bool.isRequired,
  triggerRefresh: PropTypes.func.isRequired,
  dateRange: PropTypes.arrayOf(PropTypes.instanceOf(DateTime)),
  period: PropTypes.string,
  selectedPeriod: PropTypes.shape({
    id: PropTypes.number.isRequired,
    sprintNumber: PropTypes.number,
    periodNumberByClientAndType: PropTypes.number,
    startDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    endDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    state: PropTypes.oneOf(Object.values(CLIENT_SPRINT_STATES)).isRequired,
    clientConsumptionPeriodType: PropTypes.string.isRequired,
    clientId: PropTypes.number.isRequired,
  }).isRequired,
}
